import { render, staticRenderFns } from "./ForgeItem.vue?vue&type=template&id=6702a3f1"
import script from "./ForgeItem.vue?vue&type=script&lang=js"
export * from "./ForgeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports